module.exports = __webpack_public_path__ + "static/media/plus-green-icon.eb7a7d57.svg";